import { useEffect, useState } from 'react'
import { mercure_url } from '../../config/constant'
import { useRef } from 'preact/compat'
import { sendDataToApp } from '../../utils/android'
import { useAppContext } from '../../context/AppContext'

export function withMercure(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return ({ subscribeTopics, ...props }) => {
    const { setIsMercureWork } = useAppContext();

    const [mercureData, setMercureData] = useState(null)
    const [interval, setCurrentInterval] = useState(null)

    const eventStreamRef = useRef(null)
    const urlRef = useRef(null)

    const connectMercure = () => {
      const streamEvent = eventStreamRef.current

      if (
        (!streamEvent || streamEvent.readyState === streamEvent?.CLOSED) &&
        urlRef.current
      ) {
        console.log('Retrying to connect to Mercure')
        const eventSource = new EventSource(urlRef.current, { withCredentials: false })

        eventSource.onopen = () => {
          console.log(`Connected to Mercure on ${urlRef.current}`)
          setIsMercureWork(true)
        }

        eventSource.onmessage = (event) => {
          const data = JSON.parse(event.data)
          console.log(`received message from Mercure : ${event.data}`)

          try {
            sendDataToApp('log', event.data)
          } catch (error) {
            console.warn(error)
          }

          setMercureData(data)
        }

        eventSource.onerror = (event) => {
          if (
            eventStreamRef.current &&
            eventStreamRef.current.readyState !== streamEvent?.CLOSED
          ) {
            eventStreamRef.current.close()
            setIsMercureWork(false)
          }
        }

        eventStreamRef.current = eventSource
      }
    }

    useEffect(() => {
      if (!subscribeTopics || !mercure_url) {
        console.warn('no subscribed topics')
        return
      }

      const url = new URL(mercure_url)

      Object.keys(subscribeTopics).map((key) => {
        // eslint-disable-next-line react/prop-types,array-callback-return
        subscribeTopics[key].map((value) => {
          if (key && value) {
            url.searchParams.append('topic', `${key}/${value}`)
          }
        })
      })

      if (url.searchParams.size === 0) {
        console.warn('no subscribed topics')
        return
      }

      urlRef.current = url

      connectMercure()
      setCurrentInterval(
        setInterval(() => {
          connectMercure()
        }, 10000),
      )

      // eslint-disable-next-line consistent-return
      return () => {
        if (eventStreamRef.current) {
          eventStreamRef.current.close()
        }

        if (interval) {
          clearInterval(interval)
        }
      }
    }, [subscribeTopics, mercure_url])

    return (
      <WrappedComponent mercureData={mercureData} subscribeTopics {...props} />
    )
  }
}
